var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!buble-loader?{\"objectAssign\":\"Object.assign\"}!../node_modules/vue-loader/lib/selector?type=script&index=0!./CsvDownload.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-280801e5!../node_modules/vue-loader/lib/selector?type=template&index=0!./CsvDownload.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/dkuck/work/vue-csv-downloader/src/CsvDownload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CsvDownload.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-280801e5", Component.options)
  } else {
    hotAPI.reload("data-v-280801e5", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/CsvDownload.vue
// module id = 4
// module chunks = 0